export async function assertLifecycleOwnerBinding(
  expectedOwnerId: string,
  readBinding: () => Promise<{ value?: unknown } | undefined>,
): Promise<void> {
  const binding = await readBinding();
  if (binding?.value !== expectedOwnerId) {
    throw new Error('content-lifecycle-owner-binding-stale');
  }
}
